import firebase from "firebase";
import { MaxTakeAwaySeliverySlots, Restaurant } from "../../models/restaurant";
import { ApprovementRequest } from "../../models/approvementRequest";

export const serializeApprovementSnap = (
  snap: firebase.firestore.DocumentSnapshot
): ApprovementRequest => {
  const data = snap.data() ?? {};
  return serializeApprovementRequest(snap.id, data);
};

export const serializeApprovementRequest = (
  id: string,
  data: {[key:string]: any}
): ApprovementRequest => {
  return {
    status: data.status,
  };
};
